// A score as a win probability, the way the score bar draws it: the share of
// the bar the side gets. Centipawn gaps overstate decided games, and this
// mapping does not, which is why the filters below measure in it.
const MATE_PAWNS = 128;
const PAWNS_PER_BAR = 4;

/** The win probability a score in centipawns gives the side it is for. */
export function winProbability(cp: number): number {
  const pawns = Math.max(-MATE_PAWNS, Math.min(MATE_PAWNS, cp / 100));
  return 0.5 + 0.5 * Math.tanh(pawns / PAWNS_PER_BAR);
}
